// Central, environment-driven site configuration.
// Business details marked `verified: false` must be confirmed by the owner before launch.

export const SITE_URL = (process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
export const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const ONLINE_FORMS_ENABLED = process.env.REACT_APP_ONLINE_FORMS_ENABLED !== "false";
export const GA4_ID = process.env.REACT_APP_GA4_ID || "";
export const GTM_ID = process.env.REACT_APP_GTM_ID || "";
export const GSC_VERIFICATION = process.env.REACT_APP_GSC_VERIFICATION || "";
// The 10% community offer stays OFF until validity, eligibility, expiry and redemption rules are confirmed.
export const COMMUNITY_OFFER_ACTIVE = String(process.env.REACT_APP_COMMUNITY_OFFER_ACTIVE).toLowerCase() === "true";

export const BUSINESS = {
  name: "Uhlumo Organics",
  legalNote: "Company Registration Number 2025/475096/07",
  registrationNumber: "2025/475096/07",
  founder: "Thozama Gloria Woji",
  founderShort: "Thozama Woji",
  established: "2024",
  industry: "Natural Wellness Products",
  values: ["Quality", "Integrity", "Wellness"],
  phoneDisplay: "065 377 8765",
  phoneE164: "+27653778765",
  whatsappDisplay: "065 377 8765",
  whatsappNumber: "27653778765",
  email: "thozama@uhlumoorganics.co.za",
  hours: "09:00 – 18:00",
  hoursNote: "Operating days to be confirmed. Please WhatsApp us to check availability.",
  address: {
    line1: "NY 52, No. 39, Shiba Street",
    suburb: "Gugulethu",
    city: "Cape Town",
    province: "Western Cape",
    postalCode: "7750",
    country: "ZA",
    countryName: "South Africa",
  },
  areaServed: "Cape Town, Western Cape, South Africa",
  // Social profiles are hidden until ownership and URLs are verified.
  social: [
    { name: "Facebook", handle: "Uhlumo Organics", url: "", verified: false },
    { name: "TikTok", handle: "Reset_Infusions", url: "", verified: false },
  ],
};

export const verifiedSocial = BUSINESS.social.filter((s) => s.verified && s.url);

export const WHATSAPP_MESSAGES = {
  general: "Hello Uhlumo Organics. I would like to enquire about your wellness products.",
  pricing: "Hello Uhlumo Organics. I would like to request pricing for your wellness products.",
};

export function whatsappLink(message = WHATSAPP_MESSAGES.general) {
  return `https://wa.me/${BUSINESS.whatsappNumber}?text=${encodeURIComponent(message)}`;
}

export const HEALTH_DISCLAIMER = [
  "The information provided on this website is for general educational and informational purposes only and is not intended as medical advice.",
  "Our products are not intended to diagnose, treat, cure, or prevent any disease.",
  "Customers should consult a qualified healthcare professional before using any wellness products, particularly if they are pregnant, nursing, taking medication, or have a medical condition.",
];

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "site-nav-home-link" },
  { to: "/products", label: "Our Products", testid: "site-nav-products-link" },
  { to: "/about", label: "About Us", testid: "site-nav-about-link" },
  { to: "/wellness-guide", label: "Wellness Guide", testid: "site-nav-wellness-link" },
  { to: "/contact", label: "Contact", testid: "site-nav-contact-link" },
];

const U = (id, w = 1400) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=70`;
export const unsplashSrcSet = (id) => [480, 800, 1200, 1600].map((w) => `${U(id, w)} ${w}w`).join(", ");

// Licensed Unsplash lifestyle imagery. These are NOT Uhlumo Organics products.
export const IMAGES = {
  ocean: { id: "photo-1591638462868-19cfad9c49d1", alt: "Gentle ocean wave rolling towards the shore in soft morning light" },
  oceanDeep: { id: "photo-1559827260-dc66d52bef19", alt: "Blue ocean wave under a soft pink evening sky" },
  coastline: { id: "photo-1631609511988-f3ab068a5190", alt: "Coastal fynbos landscape meeting a calm blue sea" },
  botanical: { id: "photo-1536882240095-0379873feb4e", alt: "Single green botanical stem with leaves on a light background" },
  leaves: { id: "photo-1518531933037-91b2f5f229cc", alt: "Dense layer of fresh green leaves" },
  hibiscus: { id: "photo-1606440894295-8a79c32fdaf4", alt: "Close-up of a red hibiscus flower" },
  beetroot: { id: "photo-1593105544559-ecb03bf76f82", alt: "Fresh beetroot with green leaves and red stems" },
  honey: { id: "photo-1558642452-9d2a7deb7f62", alt: "Honey dripping from a wooden honey dipper into an unlabelled glass jar" },
  beach: { id: "photo-1545205597-3d9d02c29597", alt: "Group stretching together on a beach in the morning" },
};
export const img = (key, w) => U(IMAGES[key].id, w);
